import { Component, ElementRef, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';

@Component({
  selector: `modal-cripto-access`,
  templateUrl: './modal-cripto-access.component.html',
  styleUrls: ['./modal-cripto-access.component.scss']
})
export class ModalCriptoAccessComponent extends DialogComponentContent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCriptoAccessComponent>,
    public element: ElementRef,
  ) {
    super(element);
  }

  public closeModal() {
      this.dialogRef.close(true);
  }
}
